import { Stack } from '@mui/material'
import Box from '@mui/material/Box/Box'
import { ReactComponent as CrossCloseLogo } from 'assets/cross_close_logo.svg'
import { INotification } from 'models/notifications'
import moment from 'moment'
import { COLORS } from 'styles/colors'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { useParseBoldTextByTags } from 'utils/parsed-bold-text-by-tag/useParseBoldTextByTags'

import { ButtonBlock } from './components/ButtonBlock/ButtonBlock'
import { DescriptionFields } from './components/DescriptionFields/DescriptionFields'
import { ShiftFields } from './components/ShiftFields/ShiftFields'

interface NotificationItemProps extends Partial<INotification> {
	remove: (id: number) => void
	setOpenNotifications: (bool: boolean) => void
}

const NotificationItem = ({
	title,
	text,
	type,
	groups,
	created_dt,
	shift,
	payload,
	remove,
	all_groups,
	object_id,
	id,
	setOpenNotifications,
}: NotificationItemProps) => {
	const parsedText = useParseBoldTextByTags()

	return (
		<Box
			sx={{
				width: '100%',
				backgroundColor: '#fff',
				borderRadius: '12px',
				marginBottom: '8px',
			}}
		>
			<Box sx={{ padding: '16px 10px 16px 16px' }}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						marginBottom: '4px',
					}}
				>
					<TypographySecondary>
						{moment(created_dt).format('dd, DD MMM YYYY, HH:mm')}
					</TypographySecondary>
					<CrossCloseLogo
						onClick={() => remove(id)}
						style={{
							stroke: COLORS.secondary,
							width: '14px',
							height: '14px',
							cursor: 'pointer',
						}}
					/>
				</Box>
				<Stack direction={'column'} gap='16px'>
					<TypographyPrimary16Bold
						sx={{
							whiteSpace: 'pre-wrap',
						}}
					>
						{title}
					</TypographyPrimary16Bold>
					{all_groups ? (
						<Box
							component={'span'}
							sx={{
								fontSize: '14px',
								padding: '8px 8px',
								background: '#f7f7f7',
								borderRadius: '12px',

								maxWidth: 'min-content',
							}}
						>
							{'Все группы'}
						</Box>
					) : (
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'row',
								flexWrap: 'wrap',
								gap: '8px',
							}}
						>
							{groups.map(group => (
								<Box
									component={'span'}
									key={group.id}
									sx={{
										fontSize: '14px',
										padding: '8px 8px',
										background: '#f7f7f7',
										borderRadius: '12px',
										whiteSpace: 'wrap',
									}}
								>
									{group.title}
								</Box>
							))}
						</Box>
					)}
					<ShiftFields shift={shift} />
					{parsedText(text)}
					<DescriptionFields items={payload.items} />
					<ButtonBlock
						type={type}
						object_id={object_id}
						setOpenNotifications={setOpenNotifications}
					/>
				</Stack>
			</Box>
		</Box>
	)
}

export default NotificationItem
